var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { TextComponent, KRWFomatToString, StyledDivider } from 'renderer/components';
import { SalesPerManagerModel } from 'renderer/models';
import Row from 'antd/lib/row';
import { PaymentHistoryQuery, ManagerQuery } from 'renderer/queries';
import Col from 'antd/lib/col';
import * as dayjs from 'dayjs';
import { COLORS } from 'renderer/styles';
import { floor, sum, isEmpty, times } from 'renderer/utils';
import { ChartWrapper, StatisticRemoteController, ColorCircle } from './StatUsing';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label } from 'recharts';
import Empty from 'antd/lib/empty';
import styled from 'styled-components';
var TICKET_COLOR = COLORS.tag5;
var PRODUCT_COLOR = COLORS.staff4;
var SERVICE_COLOR = COLORS.tag6;
var REFUND_COLOR = COLORS.staff1;
export var StatByDuration = function (props) {
    var _a, _b, _c, _d;
    var storeId = (_a = props.store) === null || _a === void 0 ? void 0 : _a.id;
    var today = dayjs();
    var manasgers = ManagerQuery.getWorkingManagersInCache();
    var _e = React.useState({
        startedAt: today.subtract(1, 'month').startOf('day').toDate(),
        endedAt: today.endOf('day').toDate(),
        interval: 'day',
        managerId: props.readAll ? 'all' : (_b = props.loginManager) === null || _b === void 0 ? void 0 : _b.id
    }), values = _e[0], setValues = _e[1];
    var stat = PaymentHistoryQuery.useSalesStatistics({
        storeId: storeId,
        startedAt: values.startedAt,
        endedAt: values.endedAt
    }, { enabled: !!storeId });
    var handleChange = function (values) {
        setValues(values);
    };
    var isAll = values.managerId === 'all';
    var paymentList = isAll
        ? stat.data
        : (_c = stat.data) === null || _c === void 0 ? void 0 : _c.filter(function (item) {
            return item.isManagerPayment(values.managerId);
        });
    // 미수금은 paidPrice에 들어가지 않지만 통계에 들어가기 때문에 더해줌
    var totalPaidPriceWithUnpaid = sum(paymentList === null || paymentList === void 0 ? void 0 : paymentList.map(function (payment) {
        return sum(payment.salesPerManagers
            .filter(function (item) { return isAll || item.managerId === values.managerId; })
            .map(function (item) { return item.paidPrice || 0; })) || 0;
    }));
    var getData = function () {
        var amountOfX = dayjs(values.endedAt).diff(values.startedAt, values.interval) + 1;
        var xList = times(amountOfX)
            .map(function (index) {
            return dayjs(values.startedAt).add(index, values.interval).startOf(values.interval).format('YYYYMMDD');
        })
            .reverse();
        return xList.map(function (xItem, index) {
            var xItemDate = dayjs(xItem);
            var target = [];
            paymentList === null || paymentList === void 0 ? void 0 : paymentList.filter(function (payment) {
                if (dayjs(payment.paidAt).isSame(xItemDate, values.interval)) {
                    payment.salesPerManagers
                        .filter(function (item) { return isAll || item.managerId === values.managerId; })
                        .map(function (spm) {
                        var _a, _b, _c;
                        var type;
                        if (payment.isUsingHistory) {
                            var using = (_a = payment.usingHistory) === null || _a === void 0 ? void 0 : _a.find(function (using) { return using.id === spm.usingHistoryId; });
                            type = ((_c = (_b = using.product) === null || _b === void 0 ? void 0 : _b.productGroup) === null || _c === void 0 ? void 0 : _c.type) || 'product';
                        }
                        else {
                            type = payment.ticket ? 'ticket' : payment.type;
                        }
                        target.push(new SalesPerManagerModel(__assign(__assign({}, spm), { type: type })));
                    });
                }
            });
            var name = values.interval === 'day'
                ? "".concat(xItemDate.format('DD'), "\uC77C")
                : values.interval === 'month'
                    ? "".concat(xItemDate.format('MM'), "\uC6D4")
                    : "".concat(xItemDate.format('YYYY'), "\uB144");
            var label = values.interval === 'day'
                ? "".concat(xItemDate.format('YYYY년 MM월 DD일'))
                : values.interval === 'month'
                    ? "".concat(xItemDate.format('YYYY년 MM월'))
                    : "".concat(xItemDate.format('YYYY'), "\uB144");
            var total = sum(target === null || target === void 0 ? void 0 : target.map(function (spm) { return spm.paidPrice || 0; })) || 0;
            var ticketTarget = target === null || target === void 0 ? void 0 : target.filter(function (spm) { return spm.type === 'ticket'; });
            var serviceTarget = target === null || target === void 0 ? void 0 : target.filter(function (spm) { return spm.type === 'service' || spm.type === 'reservationFee'; });
            var productTarget = target === null || target === void 0 ? void 0 : target.filter(function (spm) { return spm.type === 'product'; });
            var refundTarget = target === null || target === void 0 ? void 0 : target.filter(function (spm) { return spm.type === 'refund'; });
            var ticket = sum(ticketTarget === null || ticketTarget === void 0 ? void 0 : ticketTarget.map(function (spm) { return spm.paidPrice || 0; })) || 0;
            var service = sum(serviceTarget === null || serviceTarget === void 0 ? void 0 : serviceTarget.map(function (spm) { return spm.paidPrice || 0; })) || 0;
            var product = sum(productTarget === null || productTarget === void 0 ? void 0 : productTarget.map(function (spm) { return spm.paidPrice || 0; })) || 0;
            var refund = sum(refundTarget === null || refundTarget === void 0 ? void 0 : refundTarget.map(function (spm) { return spm.paidPrice || 0; })) || 0;
            return {
                key: "".concat(xItem, "_").concat(index),
                label: label,
                name: name,
                percentage: floor((total / totalPaidPriceWithUnpaid) * 100, 1),
                total: ticket + product + service + refund,
                ticket: ticket,
                product: product,
                service: service,
                refund: refund,
                totalPaidPriceWithUnpaid: totalPaidPriceWithUnpaid
            };
        });
    };
    var data = getData();
    var selecteManagerName = ((_d = (manasgers || []).filter(Boolean).find(function (manager) { return manager.id === (values === null || values === void 0 ? void 0 : values.managerId); })) === null || _d === void 0 ? void 0 : _d.displayName) || '전체';
    var isEmptyData = isEmpty(data) || totalPaidPriceWithUnpaid === 0;
    return (React.createElement("div", null,
        React.createElement(StatisticRemoteController, { readAll: props.readAll, managers: props.readAll ? manasgers : [props.loginManager], intervalSelector: true, storeId: storeId, onChange: handleChange, values: values }),
        React.createElement(ChartWrapper, null,
            React.createElement(TextComponent, { type: "headline2", marginBottom: 44, textAlign: "center" },
                dayjs(values.startedAt).format('YYYY년 MM월 DD일'),
                " ~ ",
                dayjs(values.endedAt).format('YYYY년 MM월 DD일'),
                " (",
                selecteManagerName,
                ")"),
            isEmptyData ? (React.createElement(Empty, null)) : (React.createElement(Row, { gutter: 16, align: "middle", justify: "space-around", style: { width: '100%' } },
                React.createElement(Col, { style: { marginBottom: '50px', width: '100%', overflowY: 'hidden', overflowX: 'scroll' } }, data ? React.createElement(StackedBarChart, { data: __spreadArray([], data, true).reverse() }) : React.createElement("div", null)),
                data && (React.createElement(Col, { span: 18 },
                    (data || [])
                        .filter(function (item) { return item.total; })
                        .map(function (item, index) {
                        return (React.createElement(DurationLegendItem, { key: item.key, label: item.label, total: item.total, service: item.service, product: item.product, refund: item.refund, ticket: item.ticket }));
                    }),
                    React.createElement(Row, { justify: "end" },
                        React.createElement(TextComponent, { type: "subtitle2", color: COLORS.gray1, marginTop: 16, children: "\uC2E4 \uB9E4\uCD9C\uC561 \uD569\uACC4 ".concat(KRWFomatToString({ value: totalPaidPriceWithUnpaid })) })))))))));
};
export var StackedBarChart = function (props) {
    return (React.createElement(ResponsiveContainer, { width: 1100, height: 400 },
        React.createElement(BarChart, { data: props.data || [], margin: {
                top: 20,
                right: 5,
                left: 0,
                bottom: 5
            } },
            React.createElement(CartesianGrid, { vertical: false, stroke: COLORS.gray6 }),
            React.createElement(XAxis, { dataKey: "name", tickLine: false, axisLine: false, interval: 0 },
                React.createElement(Label, { offset: 0, position: "insideBottom", fontSize: 13 })),
            React.createElement(YAxis, { height: 50, tickCount: 8, tickLine: false, axisLine: false, width: 80, tickFormatter: function (value) {
                    return KRWFomatToString({ value: value });
                } }),
            React.createElement(Tooltip, { content: React.createElement(CustomTooltip, null) }),
            React.createElement(Bar, { dataKey: "ticket", stackId: "a", fill: TICKET_COLOR }),
            React.createElement(Bar, { dataKey: "product", stackId: "a", fill: PRODUCT_COLOR }),
            React.createElement(Bar, { dataKey: "service", stackId: "a", fill: SERVICE_COLOR }),
            React.createElement(Bar, { dataKey: "refund", stackId: "b", fill: REFUND_COLOR }))));
};
export var DurationLegendItem = function (props) {
    return (React.createElement("div", null,
        React.createElement(Row, { style: { width: '100%' }, align: "middle", justify: "space-between", gutter: 16 },
            React.createElement(Col, null,
                React.createElement(TextComponent, { type: "subtitle1", color: COLORS.gray1, marginRight: 30 }, props.label)),
            React.createElement(Col, null,
                React.createElement(Row, { justify: "space-between" },
                    React.createElement(FixedCol, { flex: 1 },
                        React.createElement(Row, { align: "middle", justify: "start" },
                            React.createElement(ColorCircle, { color: SERVICE_COLOR }),
                            React.createElement(TextComponent, { type: "body4", color: COLORS.gray2, marginLeft: 8, ellipsis: true },
                                "\uC2DC\uC220 ",
                                KRWFomatToString({ value: props.service })))),
                    React.createElement(FixedCol, { flex: 1 },
                        React.createElement(Row, { align: "middle", justify: "start" },
                            React.createElement(ColorCircle, { color: PRODUCT_COLOR }),
                            React.createElement(TextComponent, { type: "body4", color: COLORS.gray2, marginLeft: 8, ellipsis: true },
                                "\uC81C\uD488 ",
                                KRWFomatToString({ value: props.product })))),
                    React.createElement(FixedCol, { flex: 1 },
                        React.createElement(Row, { align: "middle", justify: "start" },
                            React.createElement(ColorCircle, { color: TICKET_COLOR }),
                            React.createElement(TextComponent, { type: "body4", color: COLORS.gray2, marginLeft: 8, ellipsis: true },
                                "\uC120\uBD88\uC561\u2219\uC815\uAE30\uAD8C ",
                                KRWFomatToString({ value: props.ticket })))),
                    React.createElement(FixedCol, { flex: 1 },
                        React.createElement(Row, { align: "middle", justify: "start" },
                            React.createElement(ColorCircle, { color: REFUND_COLOR }),
                            React.createElement(TextComponent, { type: "body4", color: COLORS.gray2, marginLeft: 8, ellipsis: true },
                                "\uD658\uBD88 ",
                                KRWFomatToString({ value: props.refund })))))),
            React.createElement(Col, { flex: 1 },
                React.createElement(Row, { justify: "end" },
                    React.createElement(TextComponent, { type: "body3", color: COLORS.gray2, marginLeft: 20 },
                        "\uCD1D ",
                        KRWFomatToString({ value: props.total }))))),
        React.createElement(StyledDivider, { marginTop: 10, marginBottom: 10 })));
};
var FixedCol = styled(Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 180px;\n"], ["\n  width: 180px;\n"])));
var CustomTooltip = function (props) {
    if (props.active) {
        var payload = props.payload;
        var ticket = payload[0], product = payload[1], service = payload[2], refund = payload[3];
        var data = product.payload;
        return (React.createElement(ChartLabelWrapper, null,
            React.createElement(TextComponent, { children: data.label, color: COLORS.gray1, marginBottom: 12, textAlign: "center" }),
            React.createElement(Row, { align: "middle" },
                React.createElement(ColorCircle, { color: service.color, width: 10 }),
                React.createElement(TextComponent, { marginLeft: 10, color: COLORS.gray2, children: "\uC2DC\uC220", type: "body5" }),
                React.createElement(Col, { flex: 1 },
                    React.createElement(Row, { justify: "end" },
                        React.createElement(TextComponent, { color: COLORS.gray2, children: KRWFomatToString({ value: data.service }), type: "body5" })))),
            React.createElement(Row, { align: "middle" },
                React.createElement(ColorCircle, { color: product.color, width: 10 }),
                React.createElement(TextComponent, { marginLeft: 10, color: COLORS.gray2, children: "\uC81C\uD488", type: "body5" }),
                React.createElement(Col, { flex: 1 },
                    React.createElement(Row, { justify: "end" },
                        React.createElement(TextComponent, { color: COLORS.gray2, children: KRWFomatToString({ value: data.product }), type: "body5" })))),
            React.createElement(Row, { align: "middle" },
                React.createElement(ColorCircle, { color: ticket.color, width: 10 }),
                React.createElement(TextComponent, { marginLeft: 10, color: COLORS.gray2, children: "\uC120\uBD88\uC561\u2219\uC815\uAE30\uAD8C", type: "body5" }),
                React.createElement(Col, { flex: 1 },
                    React.createElement(Row, { justify: "end" },
                        React.createElement(TextComponent, { color: COLORS.gray2, children: KRWFomatToString({ value: data.ticket }), type: "body5" })))),
            React.createElement(Row, { align: "middle" },
                React.createElement(ColorCircle, { color: refund.color, width: 10 }),
                React.createElement(TextComponent, { marginLeft: 10, color: COLORS.gray2, children: "\uD658\uBD88", type: "body5" }),
                React.createElement(Col, { flex: 1 },
                    React.createElement(Row, { justify: "end" },
                        React.createElement(TextComponent, { color: COLORS.gray2, children: KRWFomatToString({ value: data.refund }), type: "body5" })))),
            React.createElement(StyledDivider, { marginTop: 4, marginBottom: 4 }),
            React.createElement(TextComponent, null),
            React.createElement(Row, { align: "middle" },
                React.createElement(ColorCircle, { color: COLORS.white, width: 10 }),
                React.createElement(TextComponent, { marginLeft: 10, color: COLORS.gray1, children: "\uC2E4 \uB9E4\uCD9C\uC561", type: "body5" }),
                React.createElement(Col, { flex: 1 },
                    React.createElement(Row, { justify: "end" },
                        React.createElement(TextComponent, { color: COLORS.gray1, children: KRWFomatToString({ value: data.product + data.ticket + data.service + data.refund }), type: "body5" }))))));
    }
    return null;
};
var ChartLabelWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 240px;\n  height: 180px;\n  padding: 25px 34px 38px 36px;\n  border-radius: 2px;\n  box-shadow: 0 0 5px 0 var(--primary-shadow);\n  border: solid 1px ", ";\n  background-color: ", ";\n"], ["\n  width: 240px;\n  height: 180px;\n  padding: 25px 34px 38px 36px;\n  border-radius: 2px;\n  box-shadow: 0 0 5px 0 var(--primary-shadow);\n  border: solid 1px ", ";\n  background-color: ", ";\n"])), COLORS.gray6, COLORS.white);
var templateObject_1, templateObject_2;
